import { render, staticRenderFns } from "./CheckBoxGroupBlock.vue?vue&type=template&id=4881516b"
import script from "./CheckBoxGroupBlock.vue?vue&type=script&lang=ts"
export * from "./CheckBoxGroupBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports